import { render, staticRenderFns } from "./ShiftOrderingSettingsTab.vue?vue&type=template&id=5bbbb659&scoped=true"
import script from "./ShiftOrderingSettingsTab.vue?vue&type=script&lang=js"
export * from "./ShiftOrderingSettingsTab.vue?vue&type=script&lang=js"
import style0 from "./ShiftOrderingSettingsTab.vue?vue&type=style&index=0&id=5bbbb659&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbbb659",
  null
  
)

export default component.exports